var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "delivery-management" },
    [
      _c(
        "el-card",
        [
          _c(
            "div",
            { staticClass: "status-tabs" },
            [
              _c("span", { staticClass: "status-tabs-label" }, [
                _vm._v("发货方式:"),
              ]),
              _vm._v(" "),
              _vm._l(_vm.sendWayTabs, function (tab) {
                return _c(
                  "span",
                  {
                    key: tab.value,
                    staticClass: "status-tab",
                    class: { active: _vm.activeSendWay === tab.value },
                    on: {
                      click: function ($event) {
                        return _vm.handleSendWayTabClick(tab.value)
                      },
                    },
                  },
                  [_vm._v(_vm._s(tab.label))]
                )
              }),
            ],
            2
          ),
          _vm._v(" "),
          _vm.activeSendWay == "配送(到家)" ||
          _vm.activeSendWay == "配送(到物流点)" ||
          _vm.activeSendWay == ""
            ? _c(
                "div",
                { staticClass: "status-tabs" },
                [
                  _c("span", { staticClass: "status-tabs-label" }, [
                    _vm._v(
                      _vm._s(
                        _vm.activeSendWay == "配送(到物流点)"
                          ? "配送(到物流点):"
                          : "配送(到家):"
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.statusTabs, function (tab) {
                    return _c(
                      "span",
                      {
                        key: tab.value,
                        staticClass: "status-tab",
                        class: { active: _vm.activeStatus === tab.value },
                        on: {
                          click: function ($event) {
                            return _vm.handleStatusTabClick(tab.value)
                          },
                        },
                      },
                      [
                        _vm._v(_vm._s(tab.label)),
                        tab.value !== null && tab.count > 0
                          ? _c("sup", { staticClass: "tab-badge" }, [
                              _vm._v(_vm._s(tab.count)),
                            ])
                          : _vm._e(),
                      ]
                    )
                  }),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.activeSendWay !== "配送(到家)" &&
          _vm.activeSendWay !== "配送(到物流点)"
            ? _c(
                "div",
                { staticClass: "status-tabs" },
                [
                  _c("span", { staticClass: "status-tabs-label" }, [
                    _vm._v("其他:"),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.otherStatusTabs, function (tab) {
                    return _c(
                      "span",
                      {
                        key: tab.value,
                        staticClass: "status-tab",
                        class: { active: _vm.activeOtherStatus === tab.value },
                        on: {
                          click: function ($event) {
                            return _vm.handleOtherStatusTabClick(tab.value)
                          },
                        },
                      },
                      [
                        _vm._v(_vm._s(tab.label)),
                        tab.value !== null && tab.count > 0
                          ? _c("sup", { staticClass: "tab-badge" }, [
                              _vm._v(_vm._s(tab.count)),
                            ])
                          : _vm._e(),
                      ]
                    )
                  }),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "top-bar" }, [
            _c("div", { staticClass: "search-box" }, [
              _c("div", { staticClass: "search-row" }, [
                _c(
                  "div",
                  { staticClass: "search-item" },
                  [
                    _c("label", [_vm._v("下单日期")]),
                    _vm._v(" "),
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        type: "daterange",
                        "range-separator": "-",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                        "value-format": "yyyy-MM-dd",
                      },
                      model: {
                        value: _vm.searchForm.orderDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "orderDate", $$v)
                        },
                        expression: "searchForm.orderDate",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "search-item" },
                  [
                    _c("label", [_vm._v("派单日期")]),
                    _vm._v(" "),
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        type: "daterange",
                        "range-separator": "-",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                        "value-format": "yyyy-MM-dd",
                      },
                      model: {
                        value: _vm.searchForm.dispatchDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "dispatchDate", $$v)
                        },
                        expression: "searchForm.dispatchDate",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "search-item" },
                  [
                    _c("label", [_vm._v("送达日期")]),
                    _vm._v(" "),
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        type: "daterange",
                        "range-separator": "-",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                        "value-format": "yyyy-MM-dd",
                      },
                      model: {
                        value: _vm.searchForm.deliveryDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "deliveryDate", $$v)
                        },
                        expression: "searchForm.deliveryDate",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "search-item" },
                  [
                    _c("label", [_vm._v("经销商")]),
                    _vm._v(" "),
                    _c("el-input", {
                      attrs: { placeholder: "经销商", clearable: "" },
                      model: {
                        value: _vm.searchForm.dealer,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "dealer", $$v)
                        },
                        expression: "searchForm.dealer",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "search-row" }, [
                _c(
                  "div",
                  { staticClass: "search-item" },
                  [
                    _c("label", [_vm._v("申请日期")]),
                    _vm._v(" "),
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        type: "daterange",
                        "range-separator": "-",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                        "value-format": "yyyy-MM-dd",
                      },
                      model: {
                        value: _vm.searchForm.applyDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "applyDate", $$v)
                        },
                        expression: "searchForm.applyDate",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "search-item" },
                  [
                    _c("label", [_vm._v("发货日期")]),
                    _vm._v(" "),
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        type: "daterange",
                        "range-separator": "-",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                        "value-format": "yyyy-MM-dd",
                      },
                      model: {
                        value: _vm.searchForm.sendDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "sendDate", $$v)
                        },
                        expression: "searchForm.sendDate",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "search-item" },
                  [
                    _c("label", [_vm._v("签收日期")]),
                    _vm._v(" "),
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        type: "daterange",
                        "range-separator": "-",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                        "value-format": "yyyy-MM-dd",
                      },
                      model: {
                        value: _vm.searchForm.signDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "signDate", $$v)
                        },
                        expression: "searchForm.signDate",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "search-item" },
                  [
                    _c("label", [_vm._v("销售单号")]),
                    _vm._v(" "),
                    _c("el-input", {
                      attrs: { placeholder: "销售单号", clearable: "" },
                      model: {
                        value: _vm.searchForm.saleNo,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "saleNo", $$v)
                        },
                        expression: "searchForm.saleNo",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "search-row" }, [
                _c(
                  "div",
                  { staticClass: "search-item" },
                  [
                    _c("label", [_vm._v("客户姓名")]),
                    _vm._v(" "),
                    _c("el-input", {
                      attrs: { placeholder: "客户姓名", clearable: "" },
                      model: {
                        value: _vm.searchForm.customerName,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "customerName", $$v)
                        },
                        expression: "searchForm.customerName",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "search-item" },
                  [
                    _c("label", [_vm._v("客户电话")]),
                    _vm._v(" "),
                    _c("el-input", {
                      attrs: { placeholder: "客户电话", clearable: "" },
                      model: {
                        value: _vm.searchForm.customerPhone,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "customerPhone", $$v)
                        },
                        expression: "searchForm.customerPhone",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "search-item" },
                  [
                    _c("label", [_vm._v("客户地址")]),
                    _vm._v(" "),
                    _c("el-input", {
                      attrs: { placeholder: "客户地址", clearable: "" },
                      model: {
                        value: _vm.searchForm.customerAddress,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "customerAddress", $$v)
                        },
                        expression: "searchForm.customerAddress",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "search-item" },
                  [
                    _c("label", [_vm._v("合同号")]),
                    _vm._v(" "),
                    _c("el-input", {
                      attrs: { placeholder: "合同号", clearable: "" },
                      model: {
                        value: _vm.searchForm.contractNo,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "contractNo", $$v)
                        },
                        expression: "searchForm.contractNo",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "search-row search-actions" }, [
                _c(
                  "div",
                  { staticClass: "search-actions-left" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", loading: _vm.searchLoading },
                        on: { click: _vm.handleSearch },
                      },
                      [_vm._v("查询")]
                    ),
                    _vm._v(" "),
                    _c("el-button", { on: { click: _vm.resetSearch } }, [
                      _vm._v("重置"),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "header-actions" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "text",
                          icon: "el-icon-download",
                          loading: _vm.exportLoading,
                        },
                        on: { click: _vm.handleExportList },
                      },
                      [_vm._v("导出")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticStyle: { "font-size": "14px" },
                        attrs: { type: "text", icon: "el-icon-setting" },
                        on: { click: _vm.openConfigDialog },
                      },
                      [_vm._v("配置")]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _vm.activeStatus === 0
            ? _c(
                "div",
                { staticStyle: { margin: "10px" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "small",
                        disabled: !_vm.hasAnySelection,
                      },
                      on: { click: _vm.handleDeliveryInstruction },
                    },
                    [_vm._v("发起")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-table",
            {
              ref: "mainTable",
              staticStyle: { width: "100%", "margin-top": "20px" },
              attrs: {
                data: _vm.tableData,
                border: "",
                "row-key": "_rowKey",
                "max-height": _vm.tableHeight,
                "header-cell-style": {
                  backgroundColor: "#e8eaed",
                  color: "#333",
                  fontWeight: "bold",
                },
              },
              on: {
                "selection-change": _vm.handleSelectionChange,
                select: _vm.handleMainSelect,
                "select-all": _vm.handleMainSelectAll,
                "row-click": _vm.handleRowClick,
              },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { type: "expand" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.contractList &&
                        scope.row.contractList.length > 0
                          ? _c(
                              "div",
                              { staticClass: "nested-table-wrapper" },
                              [
                                _c(
                                  "el-table",
                                  {
                                    ref: "contractTable_" + scope.row._rowKey,
                                    staticStyle: {
                                      width: "100%",
                                      "font-size": "13px",
                                    },
                                    attrs: {
                                      data: scope.row.contractList,
                                      size: "small",
                                      "header-cell-style": {
                                        backgroundColor: "#e8eaed",
                                        color: "#333",
                                        fontWeight: "bold",
                                      },
                                      border: "",
                                      "row-key": "_rowKey",
                                    },
                                    on: {
                                      "selection-change": function (val) {
                                        return _vm.handleNestedSelectionChange(
                                          scope.row._rowKey,
                                          val
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "solutionName",
                                        label: "生产方案",
                                        width: "120",
                                        align: "center",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "是否齐套",
                                        width: "90",
                                        align: "center",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (row) {
                                              return [
                                                _c(
                                                  "el-tag",
                                                  {
                                                    attrs: {
                                                      type:
                                                        row.row.isAll === "是"
                                                          ? "success"
                                                          : "warning",
                                                      size: "mini",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        row.row.isAll === "是"
                                                          ? "已齐套"
                                                          : "未齐套"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "area",
                                        label: "面积",
                                        width: "80",
                                        align: "center",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (row) {
                                              return [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(row.row.area || "-")
                                                  ),
                                                ]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "vol",
                                        label: "体积",
                                        width: "80",
                                        align: "center",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (row) {
                                              return [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      row.row.vol != null
                                                        ? row.row.vol
                                                        : "-"
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "packages",
                                        label: "总包数",
                                        width: "80",
                                        align: "center",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "inPackages",
                                        label: "入库数",
                                        width: "80",
                                        align: "center",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (row) {
                                              return [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      row.row.inPackages != null
                                                        ? row.row.inPackages
                                                        : "-"
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "未入数",
                                        width: "80",
                                        align: "center",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (row) {
                                              return [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      row.row.packages !=
                                                        null &&
                                                        row.row.inPackages !=
                                                          null
                                                        ? row.row.packages -
                                                            row.row.inPackages
                                                        : "-"
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "warehouse",
                                        label: "仓库",
                                        width: "100",
                                        align: "center",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (row) {
                                              return [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      row.row.warehouse || "-"
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "库位",
                                        width: "100",
                                        align: "center",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (row) {
                                              return [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      row.row.location || "-"
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", "min-width": "150", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            staticClass: "pending-action-btn",
                            staticStyle: { color: "#409EFF" },
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.$message.info("功能未开发")
                              },
                            },
                          },
                          [_vm._v("图纸")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "pending-action-btn",
                            staticStyle: { color: "#409EFF" },
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.$message.info("功能未开发")
                              },
                            },
                          },
                          [_vm._v("BOM")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "pending-action-btn",
                            staticStyle: { color: "#409EFF" },
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.$message.info("功能未开发")
                              },
                            },
                          },
                          [_vm._v("模型")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _vm._l(_vm.tableHeader, function (col) {
                return _vm.isColumnVisible(col.key)
                  ? _c("el-table-column", {
                      key: col.key + "_" + _vm.tableRenderKey,
                      attrs: {
                        prop: col.key,
                        width: col.width || undefined,
                        "min-width": !col.width
                          ? _vm.getColumnWidth(col.key)
                          : undefined,
                        label: col.label,
                        align:
                          col.key === "color" || col.key === "colorDesc"
                            ? "left"
                            : "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                col.key === "status" || col.key === "statusTag"
                                  ? _c(
                                      "span",
                                      [
                                        _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: _vm.getStatusInfo(
                                                scope.row.status
                                              ).type,
                                              size: "mini",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getStatusInfo(
                                                  scope.row.status
                                                ).label
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : (col.key === "deliveryNo" ||
                                      col.key === "sendNumber") &&
                                    _vm.getColumnValue(col.key, scope.row) !==
                                      "-"
                                  ? _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          color: "#409EFF",
                                          cursor: "pointer",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.handleDetail(scope.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getColumnValue(
                                              col.key,
                                              scope.row
                                            )
                                          )
                                        ),
                                      ]
                                    )
                                  : col.key === "deliveryNo" ||
                                    col.key === "sendNumber"
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getColumnValue(col.key, scope.row)
                                        )
                                      ),
                                    ])
                                  : col.key === "attachment" ||
                                    col.key === "collectionImg" ||
                                    col.key === "logisticsNo" ||
                                    col.key === "shipList" ||
                                    col.key === "loadingCompleteImg" ||
                                    col.key === "siteCheckImg" ||
                                    col.key === "siteCheckVideo" ||
                                    col.key === "deliveryCompleteImg" ||
                                    col.key === "deliveryReceipt"
                                  ? _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          color: "#409EFF",
                                          cursor: "pointer",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.handleImageClick(
                                              scope.row,
                                              col.key
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getColumnValue(
                                              col.key,
                                              scope.row
                                            )
                                          )
                                        ),
                                      ]
                                    )
                                  : col.key === "color" ||
                                    col.key === "colorDesc"
                                  ? _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "white-space": "pre-line",
                                          "text-align": "left",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getColumnValue(
                                              col.key,
                                              scope.row
                                            )
                                          )
                                        ),
                                      ]
                                    )
                                  : _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getColumnValue(col.key, scope.row)
                                        )
                                      ),
                                    ]),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  : _vm._e()
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c("el-pagination", {
            staticStyle: { "margin-top": "20px", "text-align": "right" },
            attrs: {
              "current-page": _vm.pagination.page,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.pagination.pageSize,
              total: _vm.pagination.total,
              layout: "total, sizes, prev, pager, next, jumper",
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.configDialogVisible,
            width: "600px",
            "close-on-click-modal": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.configDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
                height: "300px",
              },
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    flex: "1",
                    "margin-right": "20px",
                    border: "1px solid #ebeef5",
                    "border-radius": "4px",
                    padding: "10px",
                  },
                },
                [
                  _c(
                    "h4",
                    {
                      staticStyle: {
                        margin: "0 0 10px 0",
                        "font-size": "14px",
                        "font-weight": "bold",
                      },
                    },
                    [_vm._v("可选列")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        height: "calc(100% - 30px)",
                        "overflow-y": "auto",
                      },
                    },
                    [
                      _vm._l(_vm.tableHeader, function (col) {
                        return !col.visible
                          ? _c(
                              "div",
                              {
                                key: col.key,
                                staticStyle: {
                                  padding: "8px",
                                  "margin-bottom": "8px",
                                  "background-color": "#fff",
                                  border: "1px solid #ebeef5",
                                  "border-radius": "4px",
                                  cursor: "pointer",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleColumnVisible(col.key)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(col.label) +
                                    "\n          "
                                ),
                              ]
                            )
                          : _vm._e()
                      }),
                      _vm._v(" "),
                      !_vm.tableHeader.some(function (col) {
                        return !col.visible
                      })
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "center",
                                color: "#909399",
                                padding: "20px",
                              },
                            },
                            [_vm._v("\n            暂无可选列\n          ")]
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "column",
                    "justify-content": "center",
                    gap: "10px",
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        icon: "el-icon-arrow-right",
                        disabled: !_vm.tableHeader.some(function (col) {
                          return !col.visible
                        }),
                      },
                      on: { click: _vm.moveAllToRight },
                    },
                    [_vm._v("全部右移")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        icon: "el-icon-arrow-left",
                        disabled: !_vm.tableHeader.some(function (col) {
                          return col.visible
                        }),
                      },
                      on: { click: _vm.moveAllToLeft },
                    },
                    [_vm._v("全部左移")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    flex: "1",
                    "margin-left": "20px",
                    border: "1px solid #ebeef5",
                    "border-radius": "4px",
                    padding: "10px",
                  },
                },
                [
                  _c(
                    "h4",
                    {
                      staticStyle: {
                        margin: "0 0 10px 0",
                        "font-size": "14px",
                        "font-weight": "bold",
                      },
                    },
                    [
                      _vm._v("已选列（"),
                      _c("i", {
                        staticClass: "el-icon-rank",
                        staticStyle: { "margin-right": "5px" },
                      }),
                      _vm._v("拖拽排序）"),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        height: "calc(100% - 30px)",
                        "overflow-y": "auto",
                      },
                      attrs: { id: "selectedColumnsList" },
                    },
                    [
                      _c(
                        "draggable",
                        {
                          staticStyle: { "min-height": "100%" },
                          attrs: {
                            options: {
                              animation: 150,
                              ghostClass: "sortable-ghost",
                              handle: ".drag-handle",
                            },
                            element: "div",
                          },
                          model: {
                            value: _vm.visibleColumns,
                            callback: function ($$v) {
                              _vm.visibleColumns = $$v
                            },
                            expression: "visibleColumns",
                          },
                        },
                        _vm._l(_vm.visibleColumns, function (col) {
                          return _c(
                            "div",
                            {
                              key: col.key,
                              staticStyle: {
                                padding: "8px",
                                "margin-bottom": "8px",
                                "background-color": "#f5f7fa",
                                "border-radius": "4px",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "space-between",
                                    "align-items": "center",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: { cursor: "pointer" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleColumnVisible(
                                            col.key
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(col.label))]
                                  ),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "el-icon-rank drag-handle",
                                    staticStyle: {
                                      cursor: "move",
                                      color: "#909399",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _vm.visibleColumns.length === 0
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "center",
                                color: "#909399",
                                padding: "20px",
                              },
                            },
                            [_vm._v("\n            暂无已选列\n          ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.resetHeaderConfig } }, [
                _vm._v("重置"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveHeaderConfig },
                },
                [_vm._v("保存配置")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.draftDialogVisible,
            title: "暂存信息选择",
            width: "700px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.draftDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "margin-bottom": "12px", color: "#606266" } },
            [
              _vm._v(
                "\n      以下方案存在暂存信息，请选择保留其中一个方案发起发货指令：\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.draftItems,
                border: "",
                "row-key": "id",
                "highlight-current-row": "",
              },
              on: { "current-change": _vm.handleDraftCurrentChange },
            },
            [
              _c("el-table-column", {
                attrs: { width: "50", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-radio",
                          {
                            attrs: { label: scope.row.id },
                            model: {
                              value: _vm.draftSelectedId,
                              callback: function ($$v) {
                                _vm.draftSelectedId = $$v
                              },
                              expression: "draftSelectedId",
                            },
                          },
                          [_vm._v(" ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "暂存信息",
                  "min-width": "400",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.getParsedSave(scope.row)
                          ? _c("div", { staticClass: "save-info-cell" }, [
                              _c("span", { staticClass: "save-info-item" }, [
                                _vm._v(
                                  "发货方式：" +
                                    _vm._s(
                                      _vm.getParsedSave(scope.row)
                                        .deliveryType || "-"
                                    )
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.getParsedSave(scope.row).receivePerson
                                ? _c(
                                    "span",
                                    { staticClass: "save-info-item" },
                                    [
                                      _vm._v(
                                        "收货人：" +
                                          _vm._s(
                                            _vm.getParsedSave(scope.row)
                                              .receivePerson
                                          )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.getParsedSave(scope.row).receivePhone
                                ? _c(
                                    "span",
                                    { staticClass: "save-info-item" },
                                    [
                                      _vm._v(
                                        "电话：" +
                                          _vm._s(
                                            _vm.getParsedSave(scope.row)
                                              .receivePhone
                                          )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.getParsedSave(scope.row).receiveAddress
                                ? _c(
                                    "span",
                                    { staticClass: "save-info-item" },
                                    [
                                      _vm._v(
                                        "地址：" +
                                          _vm._s(
                                            _vm.getParsedSave(scope.row)
                                              .receiveAddress
                                          )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.getParsedSave(scope.row).sendDate
                                ? _c(
                                    "span",
                                    { staticClass: "save-info-item" },
                                    [
                                      _vm._v(
                                        "上门日期：" +
                                          _vm._s(
                                            _vm.getParsedSave(scope.row)
                                              .sendDate
                                          )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.getParsedSave(scope.row).doorTime &&
                              _vm.getParsedSave(scope.row).doorTime.length
                                ? _c(
                                    "span",
                                    { staticClass: "save-info-item" },
                                    [
                                      _vm._v(
                                        "上门时间：" +
                                          _vm._s(
                                            _vm
                                              .getParsedSave(scope.row)
                                              .doorTime.join(" ~ ")
                                          )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ])
                          : _c("span", { staticStyle: { color: "#909399" } }, [
                              _vm._v("-"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.draftItems.length === 0
            ? _c(
                "div",
                {
                  staticStyle: {
                    "text-align": "center",
                    padding: "20px",
                    color: "#909399",
                  },
                },
                [_vm._v("\n      暂无可选的暂存方案\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.draftDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "warning" },
                  on: { click: _vm.clearDraftAndGo },
                },
                [_vm._v("清空重新填写")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: !_vm.draftSelectedId },
                  on: { click: _vm.confirmDraftSelection },
                },
                [_vm._v("\n        确认发起\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.attachmentDialogVisible,
            title: "附件预览",
            width: "600px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.attachmentDialogVisible = $event
            },
          },
        },
        [
          _vm.attachmentPreviewList.length > 0
            ? _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-wrap": "wrap",
                    gap: "8px",
                  },
                },
                [
                  _vm._l(_vm.attachmentPreviewList, function (item, idx) {
                    return [
                      item.isImage
                        ? _c("el-image", {
                            key: "img" + idx,
                            staticStyle: {
                              width: "80px",
                              height: "80px",
                              "border-radius": "4px",
                            },
                            attrs: {
                              src: item.url,
                              "preview-src-list": _vm.attachmentPreviewList
                                .filter(function (i) {
                                  return i.isImage
                                })
                                .map(function (i) {
                                  return i.url
                                }),
                              fit: "cover",
                            },
                          })
                        : item.isVideo
                        ? _c("video", {
                            key: "vid" + idx,
                            staticStyle: {
                              width: "240px",
                              height: "135px",
                              "border-radius": "4px",
                            },
                            attrs: { src: item.url, controls: "" },
                          })
                        : _c(
                            "span",
                            {
                              key: "file" + idx,
                              staticClass: "attachment-file-item",
                              on: {
                                click: function ($event) {
                                  return _vm.downloadAttachment(item)
                                },
                              },
                            },
                            [_vm._v(_vm._s(item.name))]
                          ),
                    ]
                  }),
                ],
                2
              )
            : _c(
                "div",
                {
                  staticStyle: {
                    "text-align": "center",
                    color: "#909399",
                    padding: "20px",
                  },
                },
                [_vm._v("暂无附件")]
              ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.attachmentDialogVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }